var map = {
	"./AuthenticateAlert.vue": "222f",
	"./RegisteredPasskeys.vue": "8bb1",
	"./SendMailInformation.vue": "f4e7",
	"./UpdateAdditionalMail.vue": "7a9b",
	"./UpdateCryptoInvestPurpose.vue": "e10a",
	"./UpdateCustomerAddress.vue": "7792",
	"./UpdateCustomerBeneficName.vue": "cbcd",
	"./UpdateCustomerName.vue": "4c43",
	"./UpdateCustomerPicAddress.vue": "594b",
	"./UpdateCustomerPicName.vue": "1770",
	"./UpdateCustomerRepName.vue": "ab0c",
	"./UpdateFxInvestPurpose.vue": "b0c3",
	"./UpdateLoginNotify.vue": "c9ad",
	"./UpdateMail.vue": "d087",
	"./UpdateMyNumber.vue": "86c1",
	"./UpdatePhone.vue": "3df0",
	"./UpdatePicPhone.vue": "6b88",
	"./UpdatePwd.vue": "094d",
	"./UpdateSecondPwd.vue": "8b99",
	"./UpdateSelfAsset.vue": "5c61",
	"./UploadIdDocument.vue": "d9d4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7730";